import { mapEnumToOptions } from '@abp/ng.core';

export enum AdsRemainingDays {
        From1To10 = 1,
        From11To20 = 2,
        From21To30 = 3,
}

export const adsRemainingDaysOptions = mapEnumToOptions(AdsRemainingDays);
